import React from 'react';

import Styles from './Navigation.module.scss';

const Navigation = (props: React.ComponentPropsWithRef<'div'>) => {
	return <div {...props} className={Styles.container}></div>;
};

export default Navigation;
